import React from 'react';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import ButtonPrimary from '../ButtonPrimary';
import useForm from './useForm';
import ScrollableIframe from '../ScrollableIframe';
import useApplication from '../../resources/applications/read';
import Disclaimers from '../Disclaimers';
import LegalLink from '../LegalLink';
import Form from '../Form';
import CheckoutSuccess from '../CheckoutSuccess';
import usePrequal from '../../resources/prequal/usePrequal';

const InstallmentLoanAgreement = () => {
  useRUMView('installment-loan-agreement');
  const { data: application } = useApplication();
  const { data: prequal } = usePrequal();
  const documentId = application.attributes.final_loan.data.attributes.current_document.id;

  const {
    form,
    handleSubmit,
    isSubmitting,
    isSuccess,
  } = useForm();

  if (isSuccess && prequal.redirectUri) {
    return (
      <CheckoutSuccess />
    );
  }

  return (
    <Screen
      header="Finalize your loan agreement."
      subheader="Please review the loan agreement and agree to terms by clicking “Accept Offer” below."
    >
      <Form form={form} onSubmit={handleSubmit} sx={{ flex: 1 }}>
        <ScrollableIframe
          name="hasViewedIframe"
          src={`/documents/${documentId}?embed=true`}
          iframeTitle="Installment Loan Agreement"
        />
        <Disclaimers variant="caption" textAlign="start">
          <>
            By clicking “Accept Offer”, you&apos;re authorizing WebBank to issue you a
            DigniFi Installment Loan. You are acknowledging receipt and agreement to the
            {' '}
            <LegalLink href="https://www.dignifi.com/privacy-policy">
              Privacy Policy
            </LegalLink>
            ,
            {' '}
            <LegalLink href="https://www.dignifi.com/e-sign-disclosure">
              E-Sign Disclosure
            </LegalLink>
            {' '}
            and the
            {' '}
            <LegalLink href={`/documents/${documentId}?embed=true`}>
              WebBank DigniFi Unsecured Loan Agreement
            </LegalLink>
            {' '}
            above. By finalizing this offer, I understand a hard inquiry will
            be placed on my credit report.
          </>
        </Disclaimers>
        <ButtonPrimary isLoading={isSubmitting}>
          Accept Offer
        </ButtonPrimary>
      </Form>
    </Screen>
  );
};

export default InstallmentLoanAgreement;
